export default __webpack_public_path__ + "static/media/replacement.f7517d25.png";